import React from 'react';
import TeamGameTable from '../../../compounds/TeamGameTable/TeamGameTable';
import EliasBackButton from '../../../atoms/EliasBackButton/EliasBackButton';
import ROUTER_URLS from '../../../utils/router/urls';
import ResultsLoading from '../../../compounds/ResultsLoading/ResultsLoading';
import Dashboard from '../../../compounds/Dashboard/Dashboard';
import { fetchNcaaMbbTeamSpanStats } from '../../../../api/ncaambb';
import { statsFilters, spanRangeOptions, PAGE_TITLE, PAGE_SUBTITLE } from './constants';
import EliasStatsFilter from '../../../compounds/EliasStatsFilter/EliasStatsFilter';
import API_URLS from '../../../../api/api_urls';
import ModalFilters from '../../../compounds/ModalFilters/ModalFilters';
import { teamAdvancedModalFilterCategories } from '../constants';
import { ContextFilterType } from '../../../types/context';
import NcaaMbbTeamFiltersLayout from '../../../compounds/ncaambb/NcaaMbbTeamFiltersLayout';
import { mapTeamRows } from '../../../utils/ncaambb/span-finder/map-results';
import { mapTeamColumns } from '../../../utils/ncaambb/span-finder/map-columns';
import withResultsLayout, { WithResultsLayoutProps } from '../../../compounds/ResultsWrapper/ResultsWrapper';
import FinderStackLayout from '../../../compounds/FinderStackLayout/FinderStackLayout';
import PlayerSpanFilters from '../../../compounds/PlayerSpanFilters/PlayerSpanFilters';
import { appendContextFilters } from '../../../utils/ncaambb/search';
import Header from '../../../compounds/Common/Header';
import EXTERNAL_URLS from '../../../utils/router/external_urls';
import NcaaMbbTeamDataInfo from '../../../compounds/ncaambb/NcaaMbbTeamInfo';
import { FINDER_TYPES } from '../../../utils/common/constants';

interface IProps extends WithResultsLayoutProps {};

const LOADING_MESSAGE = 'Spans are data intensive and may take longer than other finders to produce results.';

function TeamStreakFinderResults({
  columnHeaders,
  resultsData,
  tableDataLoading,
  filtersLoading,
  error,
  handleDone,
  pageOrSortDataFetch
}: IProps) {
  const pageSpecificSearchEnabled = (context: ContextFilterType): boolean =>
    Boolean(context.spanLength) && Number(context.spanLength) > 1;

  const statsFilterPartial = <EliasStatsFilter statsFilterOptions={statsFilters} displayYearInfo={false} />;
  const bottomModalPartial = (
    <ModalFilters
      buttonTitle='Advanced Filters'
      filters={teamAdvancedModalFilterCategories}
      filterType='advancedFilters'
      finderType={FINDER_TYPES.TEAM_SPAN}
    />
  );

  return (
    <Dashboard loading={filtersLoading}>
      <FinderStackLayout
        header={
          <Header
            title={PAGE_TITLE}
            subtitle={PAGE_SUBTITLE}
            backButton={
              <EliasBackButton route={ROUTER_URLS.ncaambb.teamSpanFinderSearch} />
            }
          />
        }
        topPanel={
          <NcaaMbbTeamFiltersLayout
            handleDone={handleDone}
            statsFilterPartial={statsFilterPartial}
            pageSpecificSearchEnabled={pageSpecificSearchEnabled}
            apiUrls={API_URLS.ncaambb}
            bottomModalPartial={bottomModalPartial}
          >
            <PlayerSpanFilters spanRangeOptions={spanRangeOptions} />
          </NcaaMbbTeamFiltersLayout>
        }
        bottomPanel={
          tableDataLoading || error ?
          <ResultsLoading error={error} loadingMessage={LOADING_MESSAGE} /> :
          <TeamGameTable
            data={resultsData?.results ?? []}
            dataCount={resultsData?.count ?? 0}
            dataMetaInfo={resultsData?.query?.back_to ?? []}
            columnData={columnHeaders || []}
            handleDone={pageOrSortDataFetch}
            linkUrls={EXTERNAL_URLS.NCAAM}
            explanationMessage={ <NcaaMbbTeamDataInfo />}
          />
        }
      />
    </Dashboard>
  );
}

export default withResultsLayout(
  TeamStreakFinderResults,
  ROUTER_URLS.ncaambb.teamSpanFinderResults,
  statsFilters,
  fetchNcaaMbbTeamSpanStats,
  mapTeamColumns,
  mapTeamRows,
  appendContextFilters,
  true, // translateNcaamFilters
  FINDER_TYPES.TEAM_SPAN,
  teamAdvancedModalFilterCategories,
);
